module.exports = __webpack_public_path__ + "static/media/nosound.78679611.png";